module.exports = __webpack_public_path__ + "0d7409f88bca8325938e46e3ef672716.svg";